// components/ui/underline-tabs.tsx

'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'
import * as React from 'react'
import { cn } from '@/lib/utils'

const UnderlineTabs = TabsPrimitive.Root

const UnderlineTabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn('flex border-b border-gray-200 space-x-4', className)}
    {...props}
  />
))
UnderlineTabsList.displayName = 'UnderlineTabsList'

const UnderlineTabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'relative pt-6 pb-3 px-6 text-sm font-medium text-muted-foreground transition-colors',
      'hover:text-foreground data-[state=active]:text-foreground',
      'data-[state=active]:after:absolute data-[state=active]:after:bottom-0 data-[state=active]:after:left-0',
      'data-[state=active]:after:h-0.5 data-[state=active]:after:w-full data-[state=active]:after:bg-themedestructive',
      className
    )}
    {...props}
  />
))
UnderlineTabsTrigger.displayName = 'UnderlineTabsTrigger'

const UnderlineTabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn('mt-4', className)}
    {...props}
  />
))
UnderlineTabsContent.displayName = 'UnderlineTabsContent'

export {
  UnderlineTabs,
  UnderlineTabsList,
  UnderlineTabsTrigger,
  UnderlineTabsContent,
}
